module.exports = __webpack_public_path__ + "static/img/0769.6712e45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0769.jpg
// module id = 107
// module chunks = 0